<template>
  <TextInput
    :id="$attrs.id || 'address_number'"
    v-bind="$attrs"
    :class="$attrs.class || 'field required'"
    :name="$attrs.name || 'address_number'"
    :label="$attrs.label || 'Número do endereço'"
    :placeholder="$attrs.placeholder || 'Ex: 100'"
    :helper-message="
      $attrs.helperMessage ||
      'Número da casa, condomínio, edifício. Digite 0 se o endereço é sem número.'
    "
    :validations="$attrs.validations || 'required|rgx:persona.residence.number'"
    @input="$emit('input', $event)"
  />
</template>
<script>
import TextInput from '@/components/ui/newComponents/TextInput.vue'
export default {
  name: 'AddressNumberInput',
  components: {
    TextInput,
  },
  inheritAttrs: false,
  emits: ['input'],
}
</script>
<style lang="scss"></style>
